import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n        max-width: ", "px;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n        max-width: ", "px;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n        max-width: ", "px;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { media } from '~layout';
var CarouselContainer = styled.div.attrs(function (_ref) {
  var imageWidth = _ref.imageWidth,
      imageHeight = _ref.imageHeight,
      viewportHeight = _ref.viewportHeight,
      imagesToShow = _ref.imagesToShow;
  return {
    style: {
      height: viewportHeight,
      maxHeight: imageHeight || 'none',
      maxWidth: imageWidth * imagesToShow
    }
  };
}).withConfig({
  displayName: "CarouselContainer",
  componentId: "sc-187u08m-0"
})(["display:block;margin:0 auto;overflow:hidden;position:relative;width:100%;", " ", " ", " ", " ", " ", ""], media.sm(_templateObject(), function (_ref2) {
  var imageWidth = _ref2.imageWidth,
      imagesToShow = _ref2.imagesToShow;
  return imageWidth * imagesToShow * 0.5;
}), media.lg(_templateObject2(), function (_ref3) {
  var imageWidth = _ref3.imageWidth,
      imagesToShow = _ref3.imagesToShow;
  return imageWidth * imagesToShow * 0.75;
}), media.xl(_templateObject3(), function (_ref4) {
  var imageWidth = _ref4.imageWidth,
      imagesToShow = _ref4.imagesToShow;
  return imageWidth * imagesToShow * 0.9;
}), function (_ref5) {
  var showDivider = _ref5.showDivider,
      backgroundColor = _ref5.backgroundColor;
  return showDivider && css(["&:before,&:after{background-color:", ";content:'';position:absolute;z-index:1;}"], backgroundColor);
}, function (_ref6) {
  var isMobile = _ref6.isMobile,
      showDivider = _ref6.showDivider,
      viewportWidth = _ref6.viewportWidth,
      imageWidth = _ref6.imageWidth;
  return !isMobile && showDivider && css(["&:before,&:after{height:100%;top:0;transform:skew(-5deg);width:", ";}&:after{box-shadow:-10px 0 10px 0 rgba(0,0,0,0.1);display:", ";right:-", ";}&:before{box-shadow:10px 0 10px rgba(0,0,0,0.1);display:", ";left:-", ";}"], rem(imageWidth * 0.1), viewportWidth <= imageWidth ? 'none' : 'block', rem(imageWidth * 0.1 / 2), viewportWidth <= imageWidth ? 'none' : 'block', rem(imageWidth * 0.1 / 2));
}, function (_ref7) {
  var isMobile = _ref7.isMobile,
      showDivider = _ref7.showDivider,
      imageHeight = _ref7.imageHeight;
  return isMobile && showDivider && css(["box-shadow:inset 0 10px 10px -10px rgba(0,0,0,0.4);&:before,&:after{width:100%;transform:skew(0deg,2deg);height:", ";}&:after{display:none;}&:before{box-shadow:0 -10px 10px 0 rgba(0,0,0,0.1);display:block;bottom:-", ";}"], rem(imageHeight * 0.05), rem(imageHeight * 0.065 * 0.5));
});
export default CarouselContainer;